import React from "react";
import { RODEO_PAGE_NAME } from "src/_config";
import Sidebar from "src/components/common/Sidebar";
const LazyLeaderboardListing = React.lazy(() => import("src/components/leaderboard-listing/LeaderboardListing"));

export default function LeaderboardListingContainer(props: Record<string, any>) {
  return (
    <React.Fragment>
      <Sidebar page={RODEO_PAGE_NAME.LEADERBOARD} />
      <React.Suspense fallback={null}>
        <LazyLeaderboardListing {...props} />
      </React.Suspense>
    </React.Fragment>
  );
}
